import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";
import { useUpdateCheck } from "react-update-notification";

export default function NotificadorAtualizacao() {

    const { status, reloadPage:reloadPageFunction } = useUpdateCheck({
        type: 'interval',
        interval: 60000,
    });

    useEffect(() => {
        if (status === 'available') {
            enqueueSnackbar("O sistema possui uma nova atualização, recomendamos que a página seja recarregada para efetivar as alterações", {
                variant: "info",
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "top"
                },
                action: (
                    <Button color="inherit" size="small" onClick={reloadPageFunction}>
                        Recarregar
                    </Button>
                )
            })
        }
    }, [status])

    return (<></>)
}